import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaUtilizadoresLayer from "../components/ListaUtilizadoresLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaUtilizadoresPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("utilizador.breadcrumb.list")} />
      <ListaUtilizadoresLayer />
    </MasterLayout>
  );
};

export default ListaUtilizadoresPage;
